import { getCitiesService } from "../../../services/userServices";

export const setCitiesAction = (cities) => {
  return async (dispatch) => {
    if (cities) {
      await dispatch({
        type: "SET_CITIES",
        payload: cities?.map((_item) => ({
          label: _item.name,
          value: _item.id,
        })),
      });
    } else {
      try {
        const { status, data } = await getCitiesService();
        if (status === 200) {
          await dispatch({
            type: "SET_CITIES",
            payload: data.list?.map((_item) => ({
              label: _item.name,
              value: _item.id,
            })),
          });
        }
      } catch ({ response }) {
        console.log("Karbama Cities");
      }
    }
  };
};

export const clearCitiesAction = () => {
  return async (dispatch) => {
    await dispatch({ type: "CLEAR_CITIES", payload: {} });
  };
};
